'use client';

import ModalAiManual from '@/components/ModalAiManual';
import ModalAnswerPicked from '@/components/ModalAnswerPicked';
import ProductAnalysisModal from '@/components/ProductAnalysisModal';
import ProductsReportModal from '@/components/ProductsReportModal';
import { GroupMergeNameModal } from '@/components/action-buttons/GroupMergeNameModal';
import { ActionButtonsModalsBindings } from '@/components/action-buttons/action-buttons-view.types';

export const ActionButtonsModals = (props: ActionButtonsModalsBindings) => {
    return (
        <>
            <ProductsReportModal
                isShown={props.isReportModalOpen}
                setIsShown={props.setIsReportModalOpen}
                activeTable={props.activeTable}
                summaryRefreshToken={props.reportSummaryRefreshToken}
                isAiAnalysisLoading={props.isAiAnalysisLoading}
                isAiAnalysisDisabled={props.isAiAnalysisDisabled}
                aiAnalysisDisabledReason={props.aiAnalysisDisabledReason}
                isAiAnalysisQuotaExhausted={props.isAiAnalysisQuotaExhausted}
                onRunAiAnalysis={props.onRunAiAnalysis}
                onOpenProducts={() => props.onSetActiveTable('products')}
                onOpenBrands={() => props.onSetActiveTable('brands')}
            />
            <ModalAiManual isShown={props.isAiModalOpen} setIsShown={props.setIsAiModalOpen} />
            <ModalAnswerPicked
                isShown={props.isAnswerModalOpen}
                setIsShown={props.setIsAnswerModalOpen}
                value={props.pickedReviewsAnswer}
                setValue={props.setPickedReviewsAnswer}
            />
            {props.isGroupTable && (
                <ProductAnalysisModal
                    isShown={props.isCombinedAnalysisModalOpen}
                    setIsShown={props.closeCombinedAnalysis}
                    data={props.openedCombinedAnalysis}
                    loading={props.isCombinedAnalysisLoading}
                    error={props.combinedAnalysisError}
                    productName={
                        props.isBrandsTable
                            ? `Выбранные бренды (${props.pickedBrandGroupsCount})`
                            : `Выбранные продукты (${props.pickedProductsCount})`
                    }
                />
            )}
            {props.isGroupMergeModalOpen && (
                <GroupMergeNameModal
                    isShown={true}
                    entityLabel={props.groupMergeEntityLabel}
                    groupNameDraft={props.groupMergeNameDraft}
                    onGroupNameDraftChange={props.setGroupMergeNameDraft}
                    onSubmit={(event) => {
                        void props.submitGroupMergeForm(event);
                    }}
                    onClose={props.closeGroupMergeModal}
                    isSubmitting={props.isGroupsMergeLoading}
                    isSubmitDisabled={props.isGroupMergeSubmitDisabled}
                />
            )}
        </>
    );
};
